import type { FaireProductEntity } from "../../entity_types/product";

export const p_7prp39jhkv: FaireProductEntity = {
  token: "p_7prp39jhkv",
  type: "product",
  name: "ProSilver Green Label 20 PPM Ionic Colloidal Silver Liquid",
  brandToken: "b_6hbq65r7cs",
  brandName: "Thrival Labs",
  imageUrl:
    "https://cdn.faire.com/fastly/0c68f956502b3077bb85524f5561a2fa634f43f07fa130c8d5a7424d291c8036.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4991d47ff2e3f795712ddd588d441eaa3670aaa2147b5548482a17ef37ea05ff.png",
    "https://cdn.faire.com/fastly/af02a796cc525e2a9abf86e367bd8963313e72d870578fa8db6847314b658f0c.png",
    "https://cdn.faire.com/fastly/36a704b7507fde3f840d72359a4beb5df1ee41bd9518070901db5e3c18ea4d61.png",
    "https://cdn.faire.com/fastly/00120cfb926a7315faeb523b78ccf618f0f9cac8ef37df036862ecfb4e2de3d0.png",
    "https://cdn.faire.com/fastly/cc83eedb311813285cbd0b0b17a4ab2a32892ee4f79fcf8962a1a7e2251cae56.png",
    "https://cdn.faire.com/fastly/6b9cf30746382a82ebec1e9a9fd270dcb8cb958164285189a23b815dafd5b681.png",
    "https://cdn.faire.com/fastly/61823dce73bdef6d9220e780315c589719db855fbfd913571552fe487da1e29a.png",
    "https://cdn.faire.com/fastly/2917f7726358920431622eb39a6049dc48203c5352821bd3561bf1ab50aff600.png",
    "https://cdn.faire.com/fastly/e91df04d370b2045c3ef60650739dedc95119693ef62a567eedf60c7152b37ed.jpeg",
    "https://cdn.faire.com/fastly/27894d7e70b71a00fd9b30756f1c2b796d251f95cd769eea2aca7ee687e044a9.png",
    "https://cdn.faire.com/fastly/1d04700eb95dd46761af0c6062c275d4737f23a5d0b0688f940f3e17182d314e.png",
    "https://cdn.faire.com/fastly/3864cd2915ebd421e66c3122f0c9063bee1de906462945ecccecce3c76101893.png",
    "https://cdn.faire.com/fastly/b3905067e1156d4167f935cbe5eb3c12d4a20a040d9a9d2de1c760fedf4a5e3d.png",
    "https://cdn.faire.com/fastly/7f221ad068ec57301b94603f1d4ab17ebebb4b4eb50c68aebaab5a287c85a701.png",
    "https://cdn.faire.com/fastly/638daaf5c684b983622e9f41a1c7183a877695ed193c0dd127cd85c8ae70008d.png",
    "https://cdn.faire.com/fastly/2016976a928412e678493b531888ddb844aad53e9d7b2e0d12bf7fefcc4c202d.png",
    "https://cdn.faire.com/fastly/ce6441344db59451c79265012764e97a91e29a16f6a7e9a24f12d560e84952b7.png",
    "https://cdn.faire.com/fastly/44f71b98057fcb6b4970a4c1ed6ed09be1a137d0ff19ceb3792a9540b89a4975.png",
  ],
  priceDollars: 17.32,
  description:
    "Naturally restore and reinforce your body’s defenses against illnesses with structured silver water. Experience “Health in Abundance” with Thrival Labs ProSILVER ionic colloidal silver liquid. ProSILVER Green Label is a 20-ppm optimized ionic colloidal silver-based natural remedy that offers active defense against illness-causing radicals and infections. Available in a 2oz nasal spray, 4oz. spray, 4oz. dropper, family-sized 8 oz., economy-sized 16 oz., and bulk-sized 32 oz. or 64 oz. bottles.",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:49.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
